import { Card } from './card';
import { Button } from './button';

interface SettingsCardProps {
	title: string;
	description?: string;
	children: React.ReactNode;
	headerAction?: React.ReactNode;
	hasChanges?: boolean;
	saving?: boolean;
	onSave?: () => void;
	onCancel?: () => void;
}

export function SettingsCard({
	title,
	description,
	children,
	headerAction,
	hasChanges,
	saving,
	onSave,
	onCancel,
}: SettingsCardProps) {
	return (
		<Card className="border-line-1 bg-surface gap-0 py-0">
			<div className="flex items-center justify-between gap-3 border-b border-line-1 px-6 py-4">
				<div className="min-w-0">
					<h3 className="text-base font-medium text-text-1">{title}</h3>
					{description && <p className="mt-0.5 text-sm text-text-3">{description}</p>}
				</div>
				{headerAction && <div className="shrink-0">{headerAction}</div>}
			</div>

			<div className="flex flex-col gap-5 p-6">{children}</div>

			{onSave && (
				<div className="flex items-center justify-end gap-2 border-t border-line-1 px-6 py-3">
					{onCancel && hasChanges && (
						<Button variant="ghost" size="sm" onClick={onCancel} disabled={saving}>
							Cancel
						</Button>
					)}
					<Button size="sm" onClick={onSave} disabled={!hasChanges || saving}>
						{saving ? 'Saving…' : 'Save changes'}
					</Button>
				</div>
			)}
		</Card>
	);
}
